<template>
    <div class="flex w-full gap-5 h-full horse-list-view justify-content-around overflow-hidden">
        <div class="section-table">
            <div class="flex justify-content-between align-items-center">
                <h2 class="page-header">{{ $t('message.horseList.header') }}</h2>
                <div class="flex gap-3 buttons-container">
                    <CustomButton v-if="userAllowedToAddNewHorse" :label="$t('message.horseList.newFoalButton')" secondary @click="addNewFoal"/>
                    <CustomButton v-if="userAllowedToAddNewHorse" :label="$t('message.horseList.newImportedHorseButton')" @click="addNewImportedHorse"/>
                </div>
            </div>
            <HorseListSearchCriteria  v-model="searchCriteria" @search="search"/>
            <HorseTable ref="horseTable" v-model="searchCriteria" v-model:selectedHorse="selectedHorse" @showForm="showForm"/>
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-end">
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <HorsePreview :selectedHorse="selectedHorse" @delete-element="reloadTable" @hideForm="hideForm"/>
        </div>
    </div>
</template>

<script>
    import HorseTable from "@/views/horse/horseList/components/HorseTable.vue";
    import BookTypeTable from "@/views/dict/booktype/components/BookTypeTable.vue";
    import CustomButton from "@/components/form/CustomButton.vue";
    import BookTypeForm from "@/views/dict/booktype/components/BookTypeForm.vue";
    import LibyanOrnament from "@/components/LibyanOrnament.vue";
    import HorsePreview from "@/views/horse/horseList/components/HorsePreview.vue";
    import CustomIconButton from "@/components/form/CustomIconButton.vue";
    import {ShowHideFormUtils} from "@/utils/ShowHideFormUtils";
    import HorseListSearchCriteria from "@/views/horse/horseList/components/HorseListSearchCriteria.vue";
    import {FilterMatchMode} from "primevue/api";
    import {SystemRole} from "@/utils/SystemRole";

    export default {
        name: "HorseListView",
        components: {
            HorseListSearchCriteria,
            CustomIconButton,
            HorsePreview,
            LibyanOrnament,
            BookTypeForm,
            CustomButton,
            BookTypeTable,
            HorseTable,
        },
        data() {
            return {
                selectedHorse: {},
                searchCriteria: this.getClearSearchCriteria(),
            }
        },
        mounted() {
            this.selectedHorse = this.getClearHorse();
        },
        methods: {
            search() {
                this.$refs.horseTable.search();
            },

            getClearHorse() {
                return {
                    "id": null,
                    "name": "",
                    "ueln": "",
                    "photoUrl": null,
                    "sex": "",
                    "imported": true,
                    "color": "",
                    "uuid": "",
                    "dateOfBirth": "",
                    "dateOfImport": "",
                    "dateOfControl": "",
                    "dateOfDeath": null,
                    "birthCountry": null,
                    "importCountry": null,
                    "controllerFullname": null,
                    "owners": [],
                    "breeders": [],
                    "father": null,
                    "mother": null,
                    "bookType": null,
                    "bookNumber": null,
                    "bookPage": null,
                    "bookAppendixNumber": null,
                    "previousBookType": null,
                    "previousBookNumber": null,
                    "previousBookPage": null,
                    "previousBookAppendixNumber": null,
                    "transponderCode": "",
                    "secondTransponderCode": "",
                    "notes": "",
                    "dnasampleExists": false,
                };
            },
            getClearSearchCriteria() {
                return {
                    studbookRegistryId: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    ueln: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    sex: { value: null, matchMode: FilterMatchMode.IN },
                    coatColorIds: { value: null, matchMode: FilterMatchMode.IN },
                    dateOfBirth: { value: null, matchMode: FilterMatchMode.IN },
                    years: { value: null, matchMode: FilterMatchMode.IN },
                    previousStudbookRegistryId: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    horseStatus: { value: null, matchMode: FilterMatchMode.IN },
                    origin: { value: null, matchMode: FilterMatchMode.IN },
                    city: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                };
            },
            reloadTable() {
                this.$refs.horseTable.search();
                this.selectedHorse = this.getClearHorse();
            },
            addNewFoal() {
                this.$router.push({name: "newFoal"});
            },
            addNewImportedHorse() {
                this.$router.push({name: "newImportedHorse"});
            },
            showForm() {
                ShowHideFormUtils.showHideVerticalCustomWidth(".section-table", ".section-details", 55);
            },
            hideForm() {
                ShowHideFormUtils.showHideVerticalCustomWidth(".section-table", ".section-details", 55, true);
            },
        },
        computed: {
            userAllowedToAddNewHorse() {
                const allowedRoles = [
                    SystemRole.FIRST_LEVEL_EDITOR,
                    SystemRole.SECOND_LEVEL_EDITOR,
                    SystemRole.ADMIN
                ];

                return allowedRoles.includes(SystemRole.getUserRole());
            }
        },
        watch: {
            selectedHorse: {
                handler(value) {
                    if (!value) {
                        this.hideForm();
                    }
                },
                deep: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../assets/theme/mytheme/variables";
    .horse-list-view {
        @media screen and (max-width: 1200px) {
            flex-direction: column;
            align-items: center;
            .section-table, .section-details {
                width: 90% !important;
                overflow-y: unset;
                height: fit-content;
            }
            .close-form-button {
                display: none;
            }
        }
        @media screen and (max-width: 650px) {
            .buttons-container {
                flex-wrap: wrap;
                justify-content: right;
                gap: 0.5rem !important;
            }
        }
    }
    .section-table, .section-details {
        transition: 1s ease-in-out;
    }
    .section-details {
        width: 0;
        height: calc(100vh - 40px - $top-bar-height);
        overflow-y: auto;
    }
</style>
